<div class="month-picker">
  <button
    mat-mini-fab
    aria-label="Navigate to the previous month"
    class="month-picker__arrow"
    color="primary"
    [disabled]="selectedReleaseMonth$ | async"
    (click)="onMonthDecrement()"
  >
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <ng-container
    [ngTemplateOutlet]="monthPicker"
    [ngTemplateOutletContext]="{ date: isForTimesheet ? timesheetDate$ : monthlyReportDate$ }"
  ></ng-container>
  <ng-template #monthPicker let-date="date">
    <div class="month-picker__container">
      <button *ngIf="date as currentMonth" mat-raised-button class="month-picker__button" (click)="picker.open()">
        <input matInput class="month-picker__input" [matDatepicker]="picker" [min]="releaseDate" />
        {{ currentMonth | async | date : 'MMMM yyyy' }}
      </button>
      <button
        *ngIf="!isCurrentMonthSelected()"
        mat-raised-button
        aria-label="Back to current month"
        class="month-picker__today"
        (click)="selectCurrentMonth()"
      >
        TODAY
      </button>
    </div>
    <mat-datepicker
      #picker
      startView="year"
      [calendarHeaderComponent]="customDatepickerHeader"
      [panelClass]="panelClass$ | async"
      [startAt]="date | async"
      (monthSelected)="onMonthChange($event, picker)"
    ></mat-datepicker>
  </ng-template>
  <button
    mat-mini-fab
    aria-label="Navigate to the next month"
    class="month-picker__arrow"
    color="primary"
    (click)="onMonthIncrement()"
  >
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
